import { Injectable, computed, signal } from '@angular/core';
import { RouteStationModel, SensorDataEndChannelClass } from '../models';

@Injectable({ providedIn: 'root' })
export class StationContextService {
  private readonly _currentStation = signal<RouteStationModel | null>(null);
  private readonly _sensorDataEndChannel = signal<SensorDataEndChannelClass | null>(null);
  private readonly _sensorDataEndChannels = signal<SensorDataEndChannelClass[]>([]);
  private readonly _isOldVersion = signal(false);

  readonly currentStation = this._currentStation.asReadonly();
  readonly sensorDataEndChannel = this._sensorDataEndChannel.asReadonly();
  readonly sensorDataEndChannels = this._sensorDataEndChannels.asReadonly();
  readonly isOldVersion = this._isOldVersion.asReadonly();

  readonly radarChannels = computed(() =>
    (this._sensorDataEndChannels() ?? []).filter((ch) => ch.fg === 1)
  );

  setStation(station: RouteStationModel): void {
    this._currentStation.set(station);
  }

  setSensorDataEndChannel(channel: SensorDataEndChannelClass): void {
    this._sensorDataEndChannel.set(channel);
  }

  setSensorDataEndChannels(channels: SensorDataEndChannelClass[]): void {
    this._sensorDataEndChannels.set(channels ?? []);
  }

  setOldVersion(isOld: boolean): void {
    this._isOldVersion.set(isOld);
  }

  clear(): void {
    this._currentStation.set(null);
    this._sensorDataEndChannel.set(null);
    this._sensorDataEndChannels.set([]);
    this._isOldVersion.set(false);
  }
}
